import { render, staticRenderFns } from "./Installments.vue?vue&type=template&id=6861b7ef"
import script from "./Installments.vue?vue&type=script&lang=js"
export * from "./Installments.vue?vue&type=script&lang=js"
import style0 from "./Installments.vue?vue&type=style&index=0&id=6861b7ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports